import React from 'react'
import { CardBody as ReactstrapCardBody, CardBodyProps } from 'reactstrap'

export const CardBody: React.FC<CardBodyProps> = props => {
  return <ReactstrapCardBody {...props} />
}
